import { UninvoicedJobsPanel } from "@/components/organisms";

export const UninvoicedJobs = () => <UninvoicedJobsPanel />;
